import React from 'react';
import { Card } from 'antd';
import SeoReportSection from '../../components/SeoReport/SeoReportSection/SeoReportSection';
import CategoryStats from '../../components/SeoReport/CategoryStats/CategoryStats';
import { SeoAuditCategoriesScores, SeoAuditCategoryStatusCounts, SeoAuditSections, SeoAuditStructure } from './types';

type Props = {
    url: string;
    sections: SeoAuditSections;
    categorizedSections: Partial<SeoAuditStructure>;
    categorizedSectionsCounts: SeoAuditCategoryStatusCounts;
    categoriesScores: SeoAuditCategoriesScores;
};

export default function AuditReportCategories({ url, sections, categorizedSections, categorizedSectionsCounts, categoriesScores }: Props) {
    return (
        <>
            {Object.entries(categorizedSections).map(([categoryName, sectionsDetails]) => (
                <Card
                    className="report-card"
                    title={categoryName}
                    key={categoryName}
                    extra={
                        <CategoryStats
                            score={categoriesScores[categoryName].score || 0}
                            passed_status_total={categorizedSectionsCounts[categoryName].passed}
                            warning_status_total={categorizedSectionsCounts[categoryName].warning}
                            failed_status_total={categorizedSectionsCounts[categoryName].failed}
                        />
                    }
                >
                    {sectionsDetails.map((sectionDetails) => {
                        const section = sections[sectionDetails.key];

                        return (
                            <SeoReportSection
                                key={sectionDetails.key}
                                sectionKey={sectionDetails.key}
                                title={sectionDetails.title}
                                relevance={sectionDetails.relevance}
                                tooltip={sectionDetails.description}
                                result={section}
                                passRate={0}
                                competitorResults={{}}
                                url={url}
                            />
                        );
                    })}
                </Card>
            ))}
        </>
    );
}
